'use client';
import { ThemeProvider } from 'styled-components';
import theme from '../styles/theme';
import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { preloadComponents } from '../utils/preloader';
import { SessionProvider } from 'next-auth/react';

import posthog from 'posthog-js'
import { PostHogProvider as PHProvider } from 'posthog-js/react'

interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  useEffect(() => {
    preloadComponents();
  }, []);

  //Initialize PostHog
  useEffect(() => {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY as string, {
          api_host: 'https://eu.i.posthog.com',
          person_profiles: 'identified_only',
          defaults: '2025-05-24'
      })
  }, [])

  return (
    <SessionProvider>
        <PHProvider client={posthog}>
          <ThemeProvider theme={theme}>
            {children}
          </ThemeProvider>
        </PHProvider>
    </SessionProvider>
  );
}